package de.ohhhmhhh.frontend.admin.helper

fun Int.format() = asDynamic().toLocaleString() as String